import {
  addEnterprise,
  bindJointCloudInfo,
  deleteAppVersion,
  deleteDeliveryRecord, deliveryApp,
  deliveryrecord,
  downloadrecord, fetcheJointCloudIDInfo, fetchEnterpriseInfo, fetchEnterpriseList,
  fetchEnterpriseListadmin
} from '@/api/enterpriseAppInfo';
import { fetchEnterpriseVerifyInfo } from '@/api/enterpriseManage';
const enterprise = {
  state: {
    enterpriseInfo: {},
    currentEid: null,
    currentMarketID: null,
    enterpriseVerifyInfo: {}
  },
  mutations: {
    SET_ENTERPRISES_INFO: (state, info) => {
      state.enterpriseInfo = info;
      state.currentEid = info.eid;
      state.currentMarketID = info.marketID;
    },
    SET_ENTERPRISES_VERIFY_INFO: (state, info) => {
      state.enterpriseVerifyInfo = info
    }
  },
  actions: {
    GetEnterpriseList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseList(resdata)
          .then(response => {
            const list = response && response.data;
            resolve(list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEnterpriseListadmin({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseListadmin(resdata)
          .then(response => {
            const list = response && response.data;
            resolve(list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetEnterpriseInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseInfo(resdata)
          .then(response => {
            if (response && response.eid) {
              commit('SET_ENTERPRISES_INFO', response);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEnterpriseVerifyInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseVerifyInfo(resdata)
          .then(response => {
            if (response && response.eid) {
              commit('SET_ENTERPRISES_VERIFY_INFO', response);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBindJointCloudInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        bindJointCloudInfo(resdata)
          .then(response => {
            const isteam = response && response.data;
            resolve(isteam);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddEnterprise({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addEnterprise(resdata)
          .then(response => {
            const isteam = response && response.data;
            commit('UPDATE_ENTERPRISE', isteam);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SetCurrentEnterprise({ commit }, enID) {
      commit('SET_CURRENT', enID);
    },

    DeleteAppVersion({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteAppVersion(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetJointCloudIDInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetcheJointCloudIDInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeliveryApp({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deliveryApp(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeliveryRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deliveryrecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DownloadRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        downloadrecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteDeliveryRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteDeliveryRecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default enterprise;



// WEBPACK FOOTER //
// ./src/store/modules/enterprise.js